"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoPanelButton = void 0;
/**
 * Created by jonas on 2024-05-23.
 */
const IconToggleButton_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/IconToggleButton");
const SlotKeypad_1 = require("../../../SlotKeypad");
const SkinLoader_1 = require("../../../SkinLoader");
class PromoPanelButton extends IconToggleButton_1.IconToggleButton {
    constructor(name, onIcons, onColors, offIcons, offColors) {
        super(name, onIcons, onColors, offIcons, offColors);
        this.freeBetNotification = new PIXI.Sprite(SkinLoader_1.SkinLoader.getTexture(SkinLoader_1.SkinLoader.VOUCHER_NOTIFICATION));
        this.freeBetNotification.anchor.set(1, 0);
        this.freeBetNotification.position.set(186, 0);
    }
    enable(enable) {
        super.enable(enable);
    }
    setIcon() {
        super.setIcon();
        this.updateNotificationIcon();
    }
    updateNotificationIcon() {
        if (SlotKeypad_1.SlotKeypad.apiPlugIn.promotionHandler.promotionData.size > 0) {
            this.addChild(this.freeBetNotification);
        }
        else {
            if (this.freeBetNotification.parent != undefined) {
                this.removeChild(this.freeBetNotification);
            }
        }
    }
}
exports.PromoPanelButton = PromoPanelButton;
//# sourceMappingURL=PromoPanelButton.js.map